// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"index-module--horizontal--3jujz","img":"index-module--img--2GjPE"};